<template>
  <div class="smy__card-full-box page-org">
    <Card
      class="smy__card-full"
      :bordered="false"
      :padding="0"
    >
    <p slot="title">
      企业管理
    </p>
    <p slot="extra" class="extra">
    </p>

    <div class="top">
      <div class="top-right" style="float:right;padding:17px 17px 0">
        <Button
          type="primary"
          class="sear 导出on"
          @click="exportFile()"
        >导出企业</Button>
    </div>
  </div>
  <DeriveModle
    v-model="batchMakeTagModal"
    title="导出企业"
    :types="2"
    manufacture="/export/generate"
    derive="/export/download"
    />
    <!-- <div class="table" style="margin:17px">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
        @on-selection-change="selection = $event"
      />
    </div>
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
      style="margin-left:17px;"
    /> -->
    </Card>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import DeriveModle from '@/components/DeriveModle'

export default {
  name: 'OldEnterpriseManage',
  components: {
    DeriveModle
  },
  data () {
    return {
      batchMakeTagModal: false
    }
  },
  computed: {
    ...mapState('table', [
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 160,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let deleteBtn = h('Poptip', {
              props: {
                confirm: true,
                title: '确认删除此内容吗？',
                width: 160,
                transfer: true
              },
              on: {
                'on-ok': () => this.deleteList(row.id)
              }
            }, [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['删除'])
            ])
            let editBtn = h('Button', {
              props: {
                type: 'ghost',
                size: 'small'
              },
              on: {
                click: () => {
                  for (let obj in this.editListForm) {
                    this.editListForm[obj] = ''
                  }
                  this.edit = 2
                  this.editListForm.id = row.id
                  this.sysroleText = '编辑资料'
                  this.editListModal = true
                  this.editListForm.name = row.name
                  this.editListForm.phone = row.phone
                  this.editListForm.loginName = row.loginName
                  this.editListForm.sysrole = row.sysrole
                }
              }
            }, ['编辑资料'])
            if (row.isMain === 1) {
              return h('span', [editBtn])
            } else {
              return h('span', [
                editBtn,
                deleteBtn
              ])
            }
          }
        },
        {
          title: '姓名',
          key: 'name',
          width: 140
        },
        {
          title: '电话号码',
          key: 'phone',
          width: 140
        },
        {
          title: '账号',
          key: 'loginName',
          width: 120
        },
        {
          title: '账号类型',
          key: 'sysrole',
          width: 120,
          render: (h, {row}) => {
            let priority = row.sysrole
            let priorityName = ''
            if (priority === 1 && row.isMain === 1) {
              priorityName = '主管理员'
            } else if (priority === 1 && row.isMain === 0) {
              priorityName = '子管理员'
            } else if (priority === 2) {
              priorityName = '渠道经理'
            } else if (priority === 3) {
              priorityName = '财务经理'
            } else if (priority === 4) {
              priorityName = '代理商管理员'
            } else if (priority === 5) {
              priorityName = '代理商业务员'
            }
            return h('span', [priorityName])
          }
        },

        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/user/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize
          }
        }),
        this.$http.get('/user/count', {
        })
      ]).then(this.$http.spread((res1, res2) => {
        this.list = res1.data
        this.count = res2.data
        this.listLoading = false
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = (pageIndex - 1)
      this.loadList()
    },
    // 导出
    exportFile (val) {
      this.batchMakeTagModal = true
    }
  },
  created () {
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
  .table {
    margin: 17px;
  }

  .page {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/oldPlatform/oldEnterpriseManage/index.vue